import React, { useEffect } from 'react';

const criticalImages = [
  '/assets/logo.png',
  '/assets/fondo 01.webp',
  '/assets/fondo 02.webp',
  '/assets/fondo 03.webp',
  '/assets/fondo 04.webp',
  '/assets/fondo 05.webp',
  '/assets/Eterite.jpg',
  '/assets/perfil01.jpg',
  '/assets/graficoHLE.png',
  '/assets/wsp.png',
  '/assets/boton fb.png',
  '/assets/boton ig.png',
  '/assets/boton yt.png',
  '/assets/boton tiktok.png'
];

const PreloadImages = () => {
  useEffect(() => {
    const preloadImages = async () => {
      const imagePromises = criticalImages.map(src => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = process.env.PUBLIC_URL + src;
          img.onload = () => {
            // Guardar en caché del navegador
            if ('caches' in window) {
              caches.open('critical-images').then(cache => {
                cache.add(process.env.PUBLIC_URL + src);
              });
            }
            resolve();
          };
          img.onerror = reject;
        });
      });

      try {
        await Promise.all(imagePromises);
        console.log('Imágenes críticas precargadas');
      } catch (error) {
        console.error('Error al precargar imágenes:', error);
      }
    };

    preloadImages();
  }, []);

  return null;
};

export default PreloadImages; 